import React from 'react';
import './App.css';

function PrivacyPolicy({ user, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full my-8 relative">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-t-lg flex justify-between items-center">
          <h1 className="text-2xl font-bold">سياسة الخصوصية</h1>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6 text-right" dir="rtl">
          {/* Last Updated */}
          <div className="bg-blue-50 border-r-4 border-blue-500 p-4 rounded">
            <p className="text-sm text-gray-600">
              <strong>آخر تحديث:</strong> {new Date().toLocaleDateString('ar-SA', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Introduction */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">مقدمة</h2>
            <p className="text-gray-700 leading-relaxed">
              نحن في <strong>אבן אמין (إيفين أمين)</strong> نلتزم بحماية خصوصية مستخدمينا. توضح سياسة الخصوصية هذه 
              كيفية جمع واستخدام وحماية المعلومات الشخصية التي تقدمها عند استخدام تطبيقنا للهواتف المحمولة وموقعنا الإلكتروني.
            </p>
            <p className="text-gray-700 leading-relaxed mt-2">
              باستخدامك لخدماتنا، فإنك توافق على جمع واستخدام المعلومات وفقاً لهذه السياسة.
            </p>
          </section>

          {/* Data Collection */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">المعلومات التي نجمعها</h2>
            
            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">1. معلومات الحساب</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>رمز الدخول:</strong> رمز فريد للوصول إلى النظام</li>
              <li><strong>الاسم:</strong> اسم المستخدم أو العامل</li>
              <li><strong>نوع الحساب:</strong> (مالك المنصة، مدير، عامل)</li>
              <li><strong>معلومات المؤسسة:</strong> اسم المؤسسة للمديرين</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">2. بيانات العمل</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>المشاريع:</strong> معلومات المشاريع (الاسم، الوصف، الحالة)</li>
              <li><strong>أيام العمل:</strong> سجل حضور العمال (التاريخ، الوقت، الموقع، الحالة)</li>
              <li><strong>المدفوعات:</strong> معلومات الرواتب والمدفوعات (المبالغ، التواريخ، الحالة)</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">3. معلومات الجهاز</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>رموز الأجهزة:</strong> لإرسال الإشعارات الفورية (FCM Tokens)</li>
              <li><strong>نوع النظام:</strong> Android أو iOS</li>
              <li><strong>معلومات الجلسة:</strong> رموز المصادقة المشفرة (JWT Tokens)</li>
            </ul>

            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">4. معلومات الاستخدام</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>سجلات النشاط:</strong> الإجراءات المتخذة داخل التطبيق</li>
              <li><strong>التواريخ والأوقات:</strong> توقيت استخدام الخدمات</li>
            </ul>
          </section>

          {/* How We Use Data */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">كيف نستخدم معلوماتك</h2>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold">1</span>
                </div>
                <div>
                  <strong className="text-gray-800">تقديم الخدمات:</strong>
                  <p className="text-gray-700">إدارة حسابات المستخدمين، تتبع أيام العمل، معالجة المدفوعات، وإدارة المشاريع.</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold">2</span>
                </div>
                <div>
                  <strong className="text-gray-800">الإشعارات:</strong>
                  <p className="text-gray-700">إرسال إشعارات فورية عن المدفوعات الجديدة والتحديثات المهمة عبر Firebase Cloud Messaging.</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold">3</span>
                </div>
                <div>
                  <strong className="text-gray-800">الأمان:</strong>
                  <p className="text-gray-700">حماية حساباتكم ومنع الاستخدام غير المصرح به من خلال التشفير والمصادقة.</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold">4</span>
                </div>
                <div>
                  <strong className="text-gray-800">تحسين الخدمات:</strong>
                  <p className="text-gray-700">فهم كيفية استخدام التطبيق لتحسين الميزات وتجربة المستخدم.</p>
                </div>
              </div>

              <div className="flex items-start space-x-3 space-x-reverse">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold">5</span>
                </div>
                <div>
                  <strong className="text-gray-800">الدعم الفني:</strong>
                  <p className="text-gray-700">الرد على استفساراتكم وحل المشاكل التقنية.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Data Storage */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">تخزين البيانات</h2>
            <div className="bg-gray-50 p-4 rounded-lg space-y-3">
              <div className="flex items-center space-x-2 space-x-reverse">
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <p className="text-gray-700"><strong>قاعدة البيانات:</strong> MongoDB مشفرة ومؤمنة</p>
              </div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <p className="text-gray-700"><strong>التشفير:</strong> رموز JWT مشفرة، كلمات المرور محمية</p>
              </div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <p className="text-gray-700"><strong>الاتصال الآمن:</strong> جميع البيانات تُنقل عبر HTTPS</p>
              </div>
              <div className="flex items-center space-x-2 space-x-reverse">
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <p className="text-gray-700"><strong>التخزين المحلي:</strong> البيانات الحساسة على الجهاز مشفرة</p>
              </div>
            </div>
          </section>

          {/* Third Party Services */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">الخدمات الخارجية</h2>
            <p className="text-gray-700 mb-3">نستخدم الخدمات الخارجية التالية لتقديم خدماتنا:</p>
            
            <div className="bg-orange-50 border-r-4 border-orange-500 p-4 rounded mb-3">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Firebase (Google)</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mr-4">
                <li><strong>الغرض:</strong> إرسال الإشعارات الفورية</li>
                <li><strong>البيانات المشاركة:</strong> رموز الأجهزة، نوع النظام</li>
                <li><strong>سياسة الخصوصية:</strong> <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">firebase.google.com/support/privacy</a></li>
              </ul>
            </div>

            <p className="text-gray-600 text-sm italic">
              لا نبيع أو نشارك معلوماتك الشخصية مع أطراف ثالثة لأغراض تسويقية.
            </p>
          </section>

          {/* Data Sharing */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">مشاركة البيانات</h2>
            <p className="text-gray-700 mb-3">نشارك معلوماتك فقط في الحالات التالية:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>داخل المؤسسة:</strong> المدراء يمكنهم الوصول إلى بيانات عمالهم فقط</li>
              <li><strong>مالك المنصة:</strong> يمكنه الوصول إلى جميع البيانات للإدارة والدعم</li>
              <li><strong>المتطلبات القانونية:</strong> عند الضرورة للامتثال للقوانين أو الأوامر القضائية</li>
              <li><strong>حماية الحقوق:</strong> لحماية حقوقنا أو سلامة المستخدمين</li>
            </ul>
          </section>

          {/* User Rights */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">حقوقك</h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">📋 الوصول إلى البيانات</h3>
                <p className="text-gray-700 text-sm">يحق لك طلب نسخة من بياناتك الشخصية</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">✏️ تصحيح البيانات</h3>
                <p className="text-gray-700 text-sm">يحق لك طلب تصحيح أي بيانات غير دقيقة</p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">🗑️ حذف البيانات</h3>
                <p className="text-gray-700 text-sm">يحق لك طلب حذف بياناتك (مع استثناءات قانونية)</p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">⛔ الاعتراض</h3>
                <p className="text-gray-700 text-sm">يحق لك الاعتراض على معالجة بياناتك</p>
              </div>
            </div>
          </section>

          {/* Data Retention */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">الاحتفاظ بالبيانات</h2>
            <p className="text-gray-700 mb-3">نحتفظ بمعلوماتك للفترات التالية:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mr-4">
              <li><strong>الحسابات النشطة:</strong> طوال فترة استخدام الخدمة</li>
              <li><strong>بيانات العمل:</strong> حسب المتطلبات القانونية والمحاسبية (عادة 7 سنوات)</li>
              <li><strong>رموز الأجهزة:</strong> حتى تسجيل الخروج أو إلغاء تثبيت التطبيق</li>
              <li><strong>السجلات الأمنية:</strong> حسب احتياجات الأمان والامتثال</li>
            </ul>
          </section>

          {/* Children's Privacy */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">خصوصية الأطفال</h2>
            <div className="bg-yellow-50 border-r-4 border-yellow-500 p-4 rounded">
              <p className="text-gray-700">
                خدماتنا غير موجهة للأطفال دون سن 18 عاماً. لا نجمع معلومات شخصية عن قصد من الأطفال. 
                إذا علمنا أن طفلاً قدم معلومات شخصية، سنحذف هذه المعلومات فوراً.
              </p>
            </div>
          </section>

          {/* Security */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">الأمان</h2>
            <p className="text-gray-700 mb-3">نتخذ التدابير التالية لحماية معلوماتك:</p>
            <div className="grid md:grid-cols-3 gap-3">
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">🔒</div>
                <p className="text-sm font-semibold text-gray-800">تشفير البيانات</p>
              </div>
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">🛡️</div>
                <p className="text-sm font-semibold text-gray-800">جدران الحماية</p>
              </div>
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">🔐</div>
                <p className="text-sm font-semibold text-gray-800">HTTPS فقط</p>
              </div>
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">👁️</div>
                <p className="text-sm font-semibold text-gray-800">مراقبة مستمرة</p>
              </div>
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">🔑</div>
                <p className="text-sm font-semibold text-gray-800">مصادقة قوية</p>
              </div>
              <div className="bg-gray-50 p-3 rounded text-center">
                <div className="text-3xl mb-2">📱</div>
                <p className="text-sm font-semibold text-gray-800">تخزين محلي آمن</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm mt-3 italic">
              رغم اتخاذنا لكل الاحتياطات الممكنة، لا يمكن ضمان الأمان المطلق عبر الإنترنت.
            </p>
          </section>

          {/* Changes to Policy */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">التغييرات على السياسة</h2>
            <p className="text-gray-700">
              قد نحدث سياسة الخصوصية هذه من وقت لآخر. سنخطركم بأي تغييرات جوهرية عبر:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-1 mr-4 mt-2">
              <li>إشعار داخل التطبيق</li>
              <li>تحديث تاريخ "آخر تحديث" أعلى هذه الصفحة</li>
              <li>بريد إلكتروني (إن أمكن)</li>
            </ul>
            <p className="text-gray-700 mt-2">
              استمرارك في استخدام الخدمات بعد التغييرات يعني موافقتك على السياسة المحدثة.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 pb-2 border-b-2 border-blue-500">اتصل بنا</h2>
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-5 rounded-lg">
              <p className="text-gray-700 mb-3">
                إذا كان لديك أي أسئلة أو استفسارات حول سياسة الخصوصية أو ممارساتنا، يرجى الاتصال بنا:
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-3 space-x-reverse">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <p className="text-gray-800 font-medium">البريد الإلكتروني: <a href="mailto:privacy@evenamen.com" className="text-blue-600 hover:underline">privacy@evenamen.com</a></p>
                </div>
                <div className="flex items-center space-x-3 space-x-reverse">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                  <p className="text-gray-800 font-medium">الموقع: <a href={window.location.origin} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{window.location.origin}</a></p>
                </div>
                <div className="flex items-center space-x-3 space-x-reverse">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <p className="text-gray-800 font-medium">التطبيق: אבן אמין (EvenAmen)</p>
                </div>
              </div>
            </div>
          </section>

          {/* Consent */}
          <section className="bg-green-50 border-2 border-green-500 p-5 rounded-lg">
            <h2 className="text-xl font-bold text-gray-800 mb-3">موافقتك</h2>
            <p className="text-gray-700">
              باستخدامك لتطبيقنا أو موقعنا الإلكتروني، فإنك توافق على سياسة الخصوصية هذه وشروط استخدامنا.
            </p>
          </section>

          {/* Footer */}
          <div className="text-center pt-6 border-t-2 border-gray-200">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} אבן אמין (EvenAmen). جميع الحقوق محفوظة.
            </p>
            <p className="text-gray-500 text-xs mt-1">
              هذه السياسة متوافقة مع متطلبات Google Play Store و Apple App Store
            </p>
          </div>
        </div>

        {/* Close Button at Bottom */}
        <div className="sticky bottom-0 bg-white border-t-2 border-gray-200 p-4 rounded-b-lg">
          <button
            onClick={onClose}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-colors"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
